<template>
  <van-popup v-model:show="innerShow" position="bottom" round closeable :style="{ height: '95%' }" @open="onOpen">
    <div class="flex flex-col h-full bg-white">
      <PopupTitle :title="title" />
      <van-search
        v-if="!hideSearch"
        v-model="innerSearchValue"
        placeholder="请输入需要搜索的内容"
        @search="onSearch"
        @clear="onSearch('')"
      />
      <div class="flex-1 overflow-hidden overflow-y-scroll">
        <van-pull-refresh
          v-if="openPullUpLoad"
          v-model="innerPullUpLoadOptions.refreshing"
          @refresh="innerPullUpLoadOptions.onRefresh"
        >
          <van-list
            v-model:loading="innerPullUpLoadOptions.loading"
            :finished="innerPullUpLoadOptions.finished"
            finished-text="没有更多了"
            @load="innerPullUpLoadOptions.onLoad"
          >
            <template v-if="columns.length > 0">
              <slot name="fixedItem"></slot>
              <PickerItem
                :columns="columns"
                :selected-columns="selectedColumns"
                :columns-field-names="innerColumnsFieldNames"
                @select="onSelect"
              >
                <template v-for="(index, name) in $slots" #[name]="slotProps">
                  <slot :name="name" v-bind="slotProps" />
                </template>
              </PickerItem>
            </template>
            <slot name="empty" v-else>
              <EmptyPage msg="" class="mt-[20px]" />
            </slot>
          </van-list>
        </van-pull-refresh>
        <template v-else>
          <template v-if="columns.length > 0">
            <slot name="fixedItem"></slot>
            <PickerItem
              :columns="columns"
              :selected-columns="selectedColumns"
              :columns-field-names="innerColumnsFieldNames"
              @select="onSelect"
            >
              <template v-for="(index, name) in $slots" #[name]="slotProps">
                <slot :name="name" v-bind="slotProps" />
              </template>
            </PickerItem>
          </template>
          <slot name="empty" v-else>
            <EmptyPage msg="没有更多了" class="mt-[20px]" />
          </slot>
        </template>
      </div>
      <FooterButton :isFixed="false" :showCancel="false" okText="确认" @submit="onConfirm" />
    </div>
  </van-popup>
</template>
<script setup>
import { watch, ref, toRefs } from "vue";
import PopupTitle from "./PopupTitle.vue";
import { useVModel } from "@vueuse/core";
import PickerItem from "./PickerItem.vue";
import { EmptyPage } from "@/components/CommonPage";
import FooterButton from "../FormView/FooterButton.vue";

const props = defineProps({
  title: String,
  show: { default: false },
  openPullUpLoad: { type: Boolean, default: false }, // 是否开启上拉加载
  pullUpLoadOptions: Object, // 开启上拉加载必须配置
  hideSearch: { type: Boolean, default: false }, // 隐藏搜索
  columns: Array,
  columnsFieldNames: Object,
  searchValue: String
});

const emit = defineEmits(["update:show", "update:searchValue", "select", "search", "confirm", "open"]);

const innerShow = useVModel(props, "show", emit);
const innerSearchValue = props.searchValue !== undefined ? useVModel(props, "searchValue", emit) : ref("");

const { pullUpLoadOptions: innerPullUpLoadOptions } = toRefs(props);

const innerColumnsFieldNames = Object.assign(
  {
    text: "text",
    value: "value",
    children: "children"
  },
  props.columnsFieldNames
);

watch(
  () => props.columns,
  () => {
    props.columns.forEach(column => {
      column["_expand"] = false;
    });
  }
);

// 当前选中的先给数组，以后扩展多选
const selectedColumns = ref([]);
const onOpen = () => {
  selectedColumns.value = [];
  emit("open");
};
const onSelect = column => {
  selectedColumns.value = [column];
  emit("select", selectedColumns.value);
};

const onConfirm = () => {
  emit("confirm", selectedColumns.value);
};

const onSearch = searchValue => {
  emit("search", searchValue);
};
</script>
